import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import {
  optionIconografiaModel,
  iconografiaValueModel
} from "@/models/optionModel";
import baseUserContextComponent from '../baseUserContextComponent';
import _ from "lodash";
@Component({})
export default class iconografiaDetails extends baseUserContextComponent {
  font: number = 1;
  visualizzazione: number = 2;
  @Prop({ default: () => [] })
  iconografie: optionIconografiaModel[];
  // getIconografieRows(opt: optionIconografiaModel) {
  //   var instance = this;
  //   return _.chunk(instance.getIcons(opt), 2);
  // }
  get getIconografieRows() {
    var instance = this;
    var res = (instance.iconografie || []).map(icon => _.chunk(instance.getIcons(icon), 2));
    return res;
  }
  getIcons(opt: optionIconografiaModel): iconografiaValueModel[] {
    if (opt == null || opt.value == null) return [];
    var opts = opt.value.filter(o => o.languageId == "it-IT");
    if (opts == null || opts.length == 0) return [];


    return opts
      .map(o => o.value)
      .sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : a.displayOrder < b.displayOrder ? -1 :
        a.label > b.label ? 1 : -1));
  }
}
